import { Filters } from '../../../../model/Filters'

const all = ['admin/organizationInterop']
const lists = [...all, 'list']
const list = (filters?: Filters) => [...lists, filters]
const details = [...all, 'detail']
const detail = (code?: string) => [...details, code]

export const organizationInteropKeys = {
  all,
  lists,
  list,
  details,
  detail,
}
